var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('table',{attrs:{"width":"100%"}},[_c('div',{attrs:{"id":"term-fine-table"}},[_c('div',[_c('h3',[_c('b',[_vm._v(_vm._s(_vm.tableTitle))])]),_c('table',[_c('thead',[_c('tr',[_vm._l((_vm.data.header),function(row,index){return [_c('th',{key:Math.random() + row,class:{
                'index-column': [
                  'plano',
                  'multa',
                  'benefício',
                  'benefício (mês)',
                  'benefício (ano)' ].includes(row.toLowerCase()),
                'blue-column': [
                  'benefício',
                  'benefício (mês)',
                  'benefício (ano)' ].includes(row.toLowerCase()),
                'black-column': ['plano', 'multa'].includes(
                  row.toLowerCase()
                ),
              },staticStyle:{"height":"10px"},attrs:{"data-index":index}},[_vm._v("\n                "+_vm._s(row)+"\n              ")])]})],2)]),_c('tbody',_vm._l((_vm.data.body),function(row,index){return _c('tr',{key:Math.random() + row,style:(_vm.shouldApplyStyle(index))},[_vm._l((row),function(tdValue,columnIndex){return [(isNaN(tdValue / 2))?_c('td',{key:Math.random() + columnIndex,class:{
                  'blue-column': [
                    'benefício',
                    'benefício (mês)',
                    'benefício (ano)' ].includes(_vm.data.header[columnIndex].toLowerCase()),
                },attrs:{"id":"tr-body","data-index":columnIndex}},[_vm._v("\n                "+_vm._s(tdValue)+"\n              ")]):_c('td',{key:Math.random() + columnIndex,class:{
                'blue-column': [
                  'benefício',
                  'benefício (mês)',
                  'benefício (ano)' ].includes(_vm.data.header[columnIndex].toLowerCase()),
              },attrs:{"data-index":columnIndex}},[_vm._v("\n                "+_vm._s(_vm._f("currencyFormat")(tdValue))+"\n              ")])]}),(index === 42)?_c('td',{style:({ 'page-break-before': 'always' })}):_vm._e()],2)}),0)])])])])}
var staticRenderFns = []

export { render, staticRenderFns }